<template>
	<div>
		<div class="bottom">
			<span class="about">
				<span><a href="http://www.micp.org.cn/plus/list.php?tid=2" target="_blank">中心简介</a></span>
				<span><a href="http://www.micp.org.cn/a/gyzwh/zzjg/" target="_blank">组织机构</a></span>
				<span><a href="http://www.micp.org.cn/a/gyzwh/zwhzc/" target="_blank">服务管理中心</a></span>
				<span><a href="http://www.micp.org.cn/a/gonggao/" target="_blank">官方公告</a></span>
				<span><a href="http://www.micp.org.cn/a/contactus/" target="_blank">关于我们</a></span>
			</span>
			<div class="about1">
				<span style="margin-right: 10px;">《工业互联网标识管理办法》</span>
				<span>国家顶级节点标识注册服务机构</span>
			</div>
			<div class="about2">
				版权所有 © 2010-2021 移动互联网服务管理中心 版权所有，并保留所有权利。渝ICP备2022010848号-1</br>
		     北京市亦庄经济技术开发区荣华南路10号荣华国际大厦5号楼12层 Tel: 010-8646 7001
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		}
	}
</script>

<style>
	.bottom{
		width:100%;
		/* min-width: 1200px; */
		text-align: center;
		background: #f5f5f5;
		padding: 30px 0;
		color: #444444;
	}
	.bottom .about
	{
		border-bottom: 1px solid #ccc;
		
		padding: 0 10px;
		padding-bottom: 5px;
		font-size: 18px;
	}
	.about1
	{
		margin-top: 15px;
		font-size: 18px;
	}
	.about2
	{
		font-size: 14px;
		margin-top: 20px;
		line-height: 30px;
	}
	.bottom .about span
	{
		margin-right: 20px;
	}
	.bottom .about span a
	{
		color: #444444;
	}
	.bottom .about span:last-child
	{
		margin: 0;
	}
	@media screen and (max-width: 640px){
		.bottom{
			width:100%;
			/* min-width: 1200px; */
			text-align: center;
			background: #f5f5f5;
			padding: 4vw 2vw;
			color: #444444;
		}
		.bottom .about
		{
			border-bottom: 1px solid #ccc;
			
			padding: 0 2vw;
			padding-bottom: 1vw;
			font-size: 14px;
		}
		.about1
		{
			margin-top: 2vw;
			font-size: 14px;
		}
		.about2
		{
			font-size: 14px;
			margin-top: 2vw;
			line-height: 24px;
		}
		.bottom .about span
		{
			margin-right: 2vw;
		}
	}
</style>
